export default "__VITE_ASSET__DcVe$_s5__"